import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckIcon, ChevronLeft, ChevronRightIcon } from "lucide-react";
import { Box, Typography } from "@mui/material";

import Image from "../../components/Image";
import { orderhistory_api } from "../../api/urls";
import Loading from "../../components/Loading";

import CancelSteps from "../order_status/CancelSteps";
import ReturnSteps from "../order_status/ReturnSteps";
import ReplaceSteps from "../order_status/ReplaceSteps";
import NoOrderImg from "../../Assests/noProdImg.svg";
import { useFetchWithPagination } from "../../hooks/useFetchWithPagination";
import moment from "moment/moment";

const YourOrder = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [isCancel, setIsCancel] = useState(false);
  const [isReturn, setIsReturn] = useState(false);
  const [isReplace, setIsReplace] = useState(false);
  const filter_url = `?last_order=${query}`;
  const { data, refetch, loading, pagination } = useFetchWithPagination(
    query ? orderhistory_api + filter_url : orderhistory_api,
  );

  const orders = data?.results || [];
  // const next = data?.next;
  // const previous = data?.previous;

  if (loading) {
    return <Loading />;
  }
  if (isCancel)
    return (
      <CancelSteps
        setIsCancel={setIsCancel}
        orderData={orders}
        refetch={refetch}
      />
    );

  if (isReturn) {
    return (
      <ReturnSteps
        setIsReturn={setIsReturn}
        orderData={orders}
        refetch={refetch}
      />
    );
  }

  if (isReplace) {
    return (
      <ReplaceSteps
        setIsReplace={setIsReplace}
        orderData={orders}
        refetch={refetch}
      />
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#F8FAFC",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "30px 20px",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "1400px", mx: "auto" }}>
        {/* Back to Store */}
        <Box
          onClick={() => navigate("/")}
          component={motion.div}
          whileHover={{ scale: 1.02 }}
          display="flex"
          alignItems="center"
          gap={1}
          sx={{
            cursor: "pointer",
            mb: 2,
            borderRadius: "8px",
          }}
        >
          <ChevronLeft size={20} />
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{
              fontFamily: "Inter",

              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0%",
            }}
          >
            Back to Store
          </Typography>
        </Box>

        {/* Page Title */}
        <div className="flex justify-between mb-4">
          <h1 className={"text-xl"}>My Orders</h1>

          <FilterDropdown setQuery={setQuery} query={query} />
        </div>

        {/* Order List */}

        <div className="grid md:grid-cols-2 gap-4">
          {orders.length > 0 &&
            orders.map((order) => (
              <div
                key={order.id}
                className={`bg-white p-4 space-y-4 hover:scale-95 transition-all ${order.tracking_flag ? "cursor-pointer" : ""}`}
                onClick={() =>
                  order.tracking_flag && navigate(`/track/${order.id}`)
                }
              >
                {/* header: status and time */}
                <div className="flex items-center gap-2">
                  {/* Delivery Status */}
                  <div
                    className={`rounded p-2 flex gap-2 items-center text-sm w-fit capitalize`}
                    style={{
                      backgroundColor: `#${order.icon_color_code}1A`,
                      color: `#${order.icon_color_code}`,
                    }}
                  >
                    <div
                      className="rounded-full h-2 w-2"
                      style={{
                        backgroundColor: `#${order.icon_color_code}`,
                      }}
                    />
                    {order.action_name}
                  </div>
                  <span className="text-gray-400">
                    | {moment(order?.created).format("DD MMMM YYYY")}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex gap-4">
                    {/* Product Image */}
                    <div className="md:w-40 md:h-40 w-25 h-25">
                      <Image
                        src={order.tagon_product_image}
                        alt="Product"
                        style={{
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                        className={"md:w-40 md:h-40 w-25 h-25"}
                      />
                    </div>

                    <div>
                      {/* Product Details */}
                      <div>
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 500, fontSize: "14px" }}
                        >
                          <span style={{ color: "#000" }}>Order ID: </span>
                          <span
                            style={{ color: "#FF775F" }}
                            className="truncate"
                          >
                            {order.order_id}
                          </span>
                        </Typography>
                        <p className="truncate mt-1 text-lg capitalize">
                          {order.product_title}
                        </p>
                        <Typography
                          variant="body1"
                          fontWeight={400}
                          mt={1}
                          sx={{
                            fontWeight: 400,
                            fontSize: "20px",
                            lineHeight: "100%",
                            letterSpacing: "0%",
                            textTransform: "capitalize",
                            marginBottom: "15px",
                          }}
                        >
                          {/* ₹ {Number(order.total_amount_paid_amt || 0).toFixed(2)}/- */}
                        </Typography>

                        <div>
                          {(order.return_flag ||
                            order?.replace_flag ||
                            order?.cancel_flag) && (
                            <div className="flex gap-2 mt-1 mb-4 text-sm text-slate-400">
                              Delivery by:{" "}
                              {moment(order.expected_delivery).format(
                                "DD MMM YYYY",
                              )}
                            </div>
                          )}
                          <div className="flex gap-2 mt-1 mb-4 text-sm text-slate-400">
                            Quantity: {order.quantity}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {order.tracking_flag && (
                    <ChevronRightIcon className="mb-8 text-slate-300" />
                  )}
                </div>
              </div>
            ))}
        </div>

        {orders?.length === 0 && (
          <div className="md:h-[80vh]">
            <div className="no-products">
              <Image
                src={NoOrderImg}
                style={{ maxWidth: "300px", margin: "auto" }}
              />

              <Typography variant="h6">No orders found</Typography>
            </div>
          </div>
        )}
      </Box>
      {pagination}
      {/* <NewOrder
        setOpenOrder={setOpenOrder}
        openOrder={openOrder}
        orderID={orderID}
        refetch={refetch}
      /> */}
    </motion.div>
  );
};

export default YourOrder;

const FilterDropdown = ({ setQuery, query }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const options = [
    { label: "Last 30 Days", value: "day-30" },
    { label: "Last 3 months", value: "month-3" },
    { label: "Last 6 months", value: "month-6" },
    { label: "Last Year", value: "year-1" },
  ];

  const findQuery = options.find((d) => d.value === query)?.label;
  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      {/* Button */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-md bg-white px-4 py-2 text-sm font-medium shadow-sm hover:bg-gray-50"
      >
        {findQuery || "Filter"}
        <svg
          className="h-4 w-4 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 z-20 mt-2 w-44 rounded-md border bg-white shadow-lg">
          <ul className="py-1 text-sm text-gray-700">
            {options.map((item) => (
              <li
                key={item.value}
                onClick={() => {
                  if (query === item.value) {
                    setQuery("");
                  } else {
                    setQuery(item.value);
                  }
                  setOpen(false);
                }}
                className="cursor-pointer px-4 py-2 hover:bg-gray-100 flex justify-between items-center"
              >
                {item.label}{" "}
                {item.value === query && (
                  <span>
                    <CheckIcon />
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
